@if (isDataLoaded()) {
  <rask-container-block class="pb-5 ms-2 ps-1">
    <div class="ps-1">
      <ng-container [formGroup]="form">
        <rask-input [label]="texts.mallNamn"
          formControlName="benamning"
          [placeholder]="texts.angeMallNamn"
          [required]="true">
        </rask-input>
        <rask-selector class="col-3"
          [label]="texts.produktionsomrade"
          [values]="produktionsomraden"
          [formatter]="ssItemFormatter"
          [viewFormatter]="ssItemViewFormatter"
          [groupBy]="poGrouper"
          (change)="produktionsOmradeChange($event)"
          [placeholder]="texts.angeProduktionsomrade">
        </rask-selector>
        <rask-checkbox
          [text]="texts.produktionsmalFilter"
          [disabled]="!selectedProduktionsOmrade"
          [attr.disabled]="!selectedProduktionsOmrade ? true : null"
          (checkedChange)="toggleProduktionsMal($event)">
        </rask-checkbox>
        <rask-checkbox
          text="Inkludera PINar för värdekap"
          class="ms-5"
          formControlName="vardekap">
        </rask-checkbox>
        <rask-info text="Produktinstruktioner för värdekap (LUMP) skickas till skördare"></rask-info>
        @if (isCKMall) {
          <rask-selector class="col-3"
            label="Uppdragsgivare"
            [values]="ckleverantorer"
            [formatter]="ssItemFormatter"
            formControlName="ckLeverantorId"
            [required]="true"
            [viewFormatter]="ssItemViewFormatter">
          </rask-selector>
        }
      </ng-container>
    </div>
    <div class="ps-3 pe-3 pt-3">
      <rask-produktval
        layout="table"
        [canEdit]="canEdit"
        [handelssortimentsgrupper]="filteredHandelssortimentsgrupper"
        [handelssortimentsgruppProduktvalsrader]="handelssortimentsgruppProduktvalsrader"
        [visaEndastMedProduktionsmal]="visaEndastMedProduktionsmal"
        [isProduktvalApplicable]="true"
        [mall]="mall"
        (onSelectionEvent)="onSelectionEvent($event)"
        (onProduktvalChangeEvent)="onProduktvalChangeEvent()">
      </rask-produktval>
      <!-- CONTENT HERE -->
    </div>
    <div class="pb-4">
      <div class="pt-4 float-end">
        <div class="p-0 float-start">
          <rask-button color="secondary" negative (click)="removeMall()">Ta bort</rask-button>
        </div>
        <div class="float-end">
          <rask-save-button color="secondary" [disabled]="!isDirty || !canBeSaved" (click)="saveAll(true)"></rask-save-button>
        </div>
      </div>
    </div>
    @if (validationContext) {
      <div class="feedback-panel">
        @for (error of validationContext.errors; track error) {
          <small class="text-danger feedback-item">{{error}}</small>
        }
      </div>
    }
  </rask-container-block>
}
